/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum ClaimStatusEnum {
    DRAFT = 'DRAFT',
    SUBMITTED = 'SUBMITTED'
}
